import type { PersonalInfo, NavItem, SocialLink, ContactInfo, SkillCategoryData, Project, BlogPost } from '../types';

export const personalInfo: PersonalInfo = {
  name: '钟智强',
  nameEn: 'Cheng Tze Keong',
  title: '资深软件工程师',
  titleEn: 'Senior Software Engineer',
  subtitle: '12年技术深耕，代码由我主宰',
  subtitleEn: '12 years of technical expertise, master of code',
  tagline: '魔丸降世，代码由我主宰',
  taglineEn: 'Born of chaos, master of code',
  bio: '12年资深软件工程师，深耕后端架构、云原生与网络安全三大领域。精通 C/C++、Erlang、Go、Java、Python、Rust 多语言技术栈，擅长高并发分布式系统设计与性能优化。深度使用 AWS 云原生服务（ECS/EKS/IAM/GuardDuty/Inspector/SageMaker），拥有丰富的容器化部署与安全治理经验。网络安全领域累计发现 2 个 CVE 国际编号与 2 个 CNVD 漏洞证书（CNVD-2026-13173、CNVD-2026-13888），开源项目覆盖端口扫描、入侵检测、目录扫描、渗透测试辅助等多个方向。',
  bioEn: 'Senior Software Engineer with 12 years of experience, deeply specialized in backend architecture, cloud-native, and cybersecurity. Proficient in C/C++, Erlang, Go, Java, Python, Rust. Expert in high-concurrency distributed system design and performance optimization. Experienced with AWS cloud-native services (ECS/EKS/IAM/GuardDuty/Inspector/SageMaker). Discovered 2 CVEs and 2 CNVD vulnerability certificates (CNVD-2026-13173, CNVD-2026-13888), with open-source projects spanning port scanning, intrusion detection, directory enumeration, and penetration testing assistance.',
  avatar: '/avatar.png',
  heroImage: '/avatar.png',
  aboutImage: '/about.png',
  location: '江西上饶',
  email: 'johnmelodymel@qq.com',
  phone: '+86 17205984030',
  yearsExperience: 12
};

export const navItems: NavItem[] = [
  { id: 'home', label: '首页', labelEn: 'Home', href: '#home', icon: 'fa-home' },
  { id: 'about', label: '关于我', labelEn: 'About', href: '#about', icon: 'fa-user' },
  { id: 'skills', label: '技能树', labelEn: 'Skills', href: '#skills', icon: 'fa-code' },
  { id: 'projects', label: '作品集', labelEn: 'Projects', href: '#projects', icon: 'fa-briefcase' },
  { id: 'blog', label: '博客', labelEn: 'Blog', href: '#blog', icon: 'fa-newspaper' },
  { id: 'contact', label: '联系我', labelEn: 'Contact', href: '#contact', icon: 'fa-envelope' }
];

export const socialLinks: SocialLink[] = [
  { name: 'GitHub', icon: 'fa-github', url: 'https://github.com/ctkqiang', color: '#333' },
  { name: 'GitCode', icon: 'fa-gitlab', url: 'https://gitcode.com/ctkqiang_sr', color: '#FC6D26' },
  { name: 'LinkedIn', icon: 'fa-linkedin', url: 'https://www.linkedin.com/in/ctkqiang/', color: '#0077B5' },
  { name: '微博', icon: 'fa-weibo', url: 'https://weibo.com/u/7815275485', color: '#E6162D' },
  { name: '小红书', icon: 'fa-book', url: 'https://www.xiaohongshu.com/user/profile/5dd25c5e000000000100bd7c', color: '#FE2C55' }
];

export const contactInfo: ContactInfo = {
  email: 'ctkqiang@dingtalk.com',
  address: '永丰街道广丰上饶市江西中国',
  qq: '3072486255',
  wechat: 'ctkqiang',
  dingtalk: 'ctkqiang'
};

export const skillCategories: SkillCategoryData[] = [
  {
    id: 'backend',
    name: '后端开发',
    nameEn: 'Backend Development',
    icon: 'fa-server',
    skills: [
      { name: 'C / C++', level: 95, category: 'backend', icon: 'devicon-c-plain' },
      { name: 'Erlang / OTP', level: 92, category: 'backend', icon: 'devicon-erlang-plain' },
      { name: 'Go', level: 90, category: 'backend', icon: 'devicon-go-plain' },
      { name: 'Java / Spring Boot', level: 88, category: 'backend', icon: 'devicon-java-plain' },
      { name: 'Python / FastAPI', level: 88, category: 'backend', icon: 'devicon-python-plain' },
      { name: 'Rust / Tokio', level: 82, category: 'backend', icon: 'devicon-rust-plain' },
      { name: 'Elixir / Phoenix', level: 75, category: 'backend', icon: 'devicon-elixir-plain' }
    ]
  },
  {
    id: 'frontend',
    name: '前端开发',
    nameEn: 'Frontend Development',
    icon: 'fa-laptop-code',
    skills: [
      { name: 'Vue.js', level: 88, category: 'frontend', icon: 'devicon-vuejs-plain' },
      { name: 'React / Next.js', level: 85, category: 'frontend', icon: 'devicon-react-plain' }
    ]
  },
  {
    id: 'mobile',
    name: '移动开发',
    nameEn: 'Mobile Development',
    icon: 'fa-mobile-alt',
    skills: [
      { name: 'Flutter / Dart', level: 90, category: 'mobile', icon: 'devicon-flutter-plain' },
      { name: 'React Native', level: 82, category: 'mobile', icon: 'devicon-react-plain' },
      { name: 'SwiftUI / iOS', level: 78, category: 'mobile', icon: 'devicon-swift-plain' },
      { name: 'Android / Java', level: 80, category: 'mobile', icon: 'devicon-android-plain' },
      { name: 'NativeScript (Vue)', level: 72, category: 'mobile', icon: 'fa-mobile' }
    ]
  },
  {
    id: 'database',
    name: '数据库与存储',
    nameEn: 'Database & Storage',
    icon: 'fa-database',
    skills: [
      { name: 'MySQL', level: 90, category: 'database', icon: 'devicon-mysql-plain' },
      { name: 'PostgreSQL', level: 85, category: 'database', icon: 'devicon-postgresql-plain' },
      { name: 'MongoDB', level: 82, category: 'database', icon: 'devicon-mongodb-plain' },
      { name: 'Redis', level: 88, category: 'database', icon: 'devicon-redis-plain' },
      { name: 'QuestDB', level: 85, category: 'database', icon: 'fa-chart-line' },
      { name: 'Cassandra', level: 78, category: 'database', icon: 'devicon-cassandra-plain' },
      { name: 'IBM Db2', level: 75, category: 'database', icon: 'fa-database' },
      { name: 'SQLite', level: 80, category: 'database', icon: 'devicon-sqlite-plain' },
      { name: 'Valkey', level: 72, category: 'database', icon: 'fa-memory' },
      { name: 'Firebase', level: 78, category: 'database', icon: 'devicon-firebase-plain' }
    ]
  },
  {
    id: 'ai',
    name: '人工智能',
    nameEn: 'Artificial Intelligence',
    icon: 'fa-brain',
    skills: [
      { name: 'TensorFlow', level: 82, category: 'ai', icon: 'devicon-tensorflow-original' },
      { name: 'PyTorch', level: 80, category: 'ai', icon: 'devicon-pytorch-plain' },
      { name: 'Keras', level: 78, category: 'ai', icon: 'fa-brain' },
      { name: 'Hugging Face', level: 75, category: 'ai', icon: 'fa-smile' },
      { name: 'YOLO / DeepSORT', level: 80, category: 'ai', icon: 'fa-eye' },
      { name: 'TensorRT', level: 75, category: 'ai', icon: 'fa-microchip' },
      { name: '计算机视觉', level: 82, category: 'ai', icon: 'fa-eye' },
      { name: '深度学习', level: 80, category: 'ai', icon: 'fa-network-wired' }
    ]
  },
  {
    id: 'security',
    name: '网络安全',
    nameEn: 'Cybersecurity',
    icon: 'fa-shield-alt',
    skills: [
      { name: 'Nmap', level: 90, category: 'security', icon: 'fa-search' },
      { name: 'SQLMap', level: 88, category: 'security', icon: 'fa-database' },
      { name: 'Burp Suite', level: 85, category: 'security', icon: 'fa-spider' },
      { name: 'Wireshark', level: 82, category: 'security', icon: 'fa-network-wired' },
      { name: 'Ghidra', level: 78, category: 'security', icon: 'fa-bug' },
      { name: 'ApkTool', level: 80, category: 'security', icon: 'fa-mobile-alt' },
      { name: 'Hydra', level: 75, category: 'security', icon: 'fa-key' },
      { name: 'Nuclei / FFuF', level: 82, category: 'security', icon: 'fa-bomb' }
    ]
  },
  {
    id: 'embedded',
    name: '嵌入式工程',
    nameEn: 'Embedded Engineering',
    icon: 'fa-microchip',
    skills: [
      { name: 'STM32', level: 78, category: 'embedded', icon: 'fa-microchip' },
      { name: 'ESP8266 / ESP32', level: 82, category: 'embedded', icon: 'fa-wifi' },
      { name: 'Arduino / AVR', level: 80, category: 'embedded', icon: 'fa-microchip' },
      { name: 'FreeRTOS', level: 75, category: 'embedded', icon: 'fa-cogs' },
      { name: 'UART / I2C / SPI', level: 85, category: 'embedded', icon: 'fa-exchange-alt' },
      { name: 'GPIO / ADC / PWM', level: 82, category: 'embedded', icon: 'fa-bolt' },
      { name: 'BLE 蓝牙', level: 78, category: 'embedded', icon: 'fa-bluetooth' }
    ]
  },
  {
    id: 'devops',
    name: '云与 DevOps',
    nameEn: 'Cloud & DevOps',
    icon: 'fa-cloud',
    skills: [
      { name: 'AWS (ECS / EKS / IAM)', level: 88, category: 'devops', icon: 'devicon-amazonwebservices-plain-wordmark' },
      { name: '阿里云', level: 82, category: 'devops', icon: 'fa-cloud' },
      { name: 'Docker', level: 85, category: 'devops', icon: 'devicon-docker-plain' },
      { name: 'Kubernetes', level: 80, category: 'devops', icon: 'devicon-kubernetes-plain' },
      { name: 'CI/CD', level: 85, category: 'devops', icon: 'fa-cogs' },
      { name: 'OpenTelemetry', level: 75, category: 'devops', icon: 'fa-chart-line' },
      { name: 'GuardDuty / Inspector', level: 80, category: 'devops', icon: 'fa-shield-virus' },
      { name: 'DigitalOcean', level: 72, category: 'devops', icon: 'fa-server' }
    ]
  }
];

export const projects: Project[] = [
  {
    id: 'bbtool',
    title: '漏洞赏金工具',
    titleEn: 'BBTool',
    description: '专为安全研究人员设计的图形化渗透测试工具集，集成多个常用安全测试工具，提供直观的用户界面。',
    descriptionEn: 'A graphical penetration testing toolkit designed for security researchers, integrating multiple common security testing tools with an intuitive user interface.',
    category: 'security',
    tags: ['Python', '渗透测试', 'GUI'],
    image: 'https://www.ctkqiang.xin/BBtool/assets/demo/1.png',
    githubUrl: 'https://github.com/ctkqiang',
    liveUrl: 'https://www.ctkqiang.xin/BBtool/public/',
    featured: true,
    createdAt: '2024-06-01'
  },
  {
    id: 'weaver',
    title: 'Weaver 安全资讯聚合器',
    titleEn: 'Weaver Security News Aggregator',
    description: '基于 Python 的安全资讯聚合工具，从多个安全资讯网站自动抓取最新安全新闻，以图形界面展示。',
    descriptionEn: 'A Python-based security news aggregation tool that automatically fetches the latest security news from multiple security news websites and displays them with a graphical interface.',
    category: 'security',
    tags: ['Python', '爬虫', 'GUI'],
    image: 'https://github.com/ctkqiang/Weaver/blob/main/assets/%E6%88%AA%E5%B1%8F2025-07-25%20%E4%B8%8B%E5%8D%8810.11.24.png?raw=true',
    githubUrl: 'https://github.com/ctkqiang/Weaver',
    featured: true,
    createdAt: '2024-08-15'
  },
  {
    id: 'backdoor-theory',
    title: '木马前后台服务',
    titleEn: 'Backdoor Theory',
    description: '基于 Erlang 构建的高并发 TCP 后门模拟框架，复刻黑客如何伪装正常应用，在后台运行隐秘通信逻辑。',
    descriptionEn: 'A high-concurrency TCP backdoor simulation framework built on Erlang, replicating how hackers disguise normal applications and run covert communication logic in the background.',
    category: 'security',
    tags: ['Erlang', 'Python', 'TCP'],
    image: 'https://github.com/ctkqiang/BackdoorTheory/raw/main/assets/erl_demo.png',
    githubUrl: 'https://github.com/ctkqiang/BackdoorTheory',
    createdAt: '2024-03-20'
  },
  {
    id: 'lqz',
    title: '灵取证',
    titleEn: 'LingQuZhi',
    description: '专业的安卓设备数据取证工具，专为执法部门、司法机构和安全调查人员设计，确保数据提取的完整性和准确性。',
    descriptionEn: 'Professional Android device data forensics tool designed for law enforcement agencies, judicial institutions, and security investigators, ensuring the integrity and accuracy of data extraction.',
    category: 'security',
    tags: ['安卓', 'C/C++', '取证'],
    image: 'https://github.com/ctkqiang/LQZ/raw/main/assets/demo.png',
    githubUrl: 'https://github.com/ctkqiang/LQZ',
    createdAt: '2024-05-10'
  },
  {
    id: 'huatuo-ai',
    title: '华佗AI',
    titleEn: 'HuaTuo AI',
    description: '基于人工智能的中药图像分类系统，通过输入图像准确识别和分类各种中草药和成分。',
    descriptionEn: 'An AI-based TCM image classification system that accurately identifies and classifies various Chinese herbal medicines and ingredients through input images.',
    category: 'ai',
    tags: ['TensorFlow', 'MobileNetV2', 'CNN', 'Python'],
    image: 'https://github.com/johnmelodyme/HuaTuoAI/raw/main/example/2.jpeg?raw=true',
    githubUrl: 'https://github.com/ctkqiang/HuaTuoAI',
    featured: true,
    createdAt: '2024-02-28'
  },
  {
    id: 'zhuying',
    title: '竹影视频清音集',
    titleEn: 'ZhuYing Video Transcription',
    description: '基于 FFmpeg 和 Whisper 的视频处理和语音转文字工具，支持批量处理和多语言识别。',
    descriptionEn: 'Video processing and speech-to-text tool based on FFmpeg and Whisper, supporting batch processing and multi-language recognition.',
    category: 'ai',
    tags: ['FFmpeg', 'Python', 'Whisper'],
    image: 'https://github.com/ctkqiang/ZhuYing/raw/main/assets/%E6%88%AA%E5%B1%8F2025-02-20%20%E4%B8%8A%E5%8D%881.42.06.png',
    githubUrl: 'https://github.com/ctkqiang/ZhuYing',
    createdAt: '2024-04-15'
  },
  {
    id: 'hsc-license',
    title: '华视车牌识别',
    titleEn: 'HSC License Plate Recognition',
    description: '基于计算机视觉的中国车牌识别系统，使用 FastAPI 构建后端服务，提供简单的 Web 界面进行车牌图片上传和识别。',
    descriptionEn: 'Chinese license plate recognition system based on computer vision, using FastAPI to build backend services, providing a simple web interface for license plate image upload and recognition.',
    category: 'ai',
    tags: ['Python', 'FastAPI', 'OpenCV'],
    image: 'https://www.ctkqiang.xin/HSC_License/assets/%E6%88%AA%E5%B1%8F2025-03-23%20%E4%B8%8B%E5%8D%887.26.29.png',
    liveUrl: 'https://ctkqiang.xin/HSC_License',
    createdAt: '2024-03-01'
  },
  {
    id: 'wangzhongzhi',
    title: '汪种知',
    titleEn: 'WangZhongZhi',
    description: '使用 Flutter 框架开发的创新性犬种识别应用，集成深度学习模型，支持 60 种犬种的实时识别。',
    descriptionEn: 'An innovative dog breed identification app developed using the Flutter framework, integrating deep learning models and supporting real-time identification of 60 dog breeds.',
    category: 'app',
    tags: ['Flutter', '深度学习', '图像识别'],
    image: 'https://github.com/ctkqiang/WangZhongZhi/blob/main/assets/images/WechatIMG32.jpg?raw=true',
    liveUrl: 'https://ctkqiang.xin/WangZhongZhi',
    featured: true,
    createdAt: '2024-07-20'
  },
  {
    id: 'nezha-ai',
    title: '哪吒 AI',
    titleEn: 'NeZha AI',
    description: '全方位网络安全平台，提供文件和URL恶意软件扫描、数据泄露检测、密码生成等数字安全防护工具。',
    descriptionEn: 'A comprehensive cybersecurity platform providing digital security protection tools including file and URL malware scanning, data breach detection, and password generation.',
    category: 'security',
    tags: ['NextJS', 'AI 安全', '网络防护'],
    image: '/assets/icons/截屏2025-07-07 下午11.53.52.png',
    liveUrl: 'https://nezha-ai.vercel.app/',
    featured: true,
    createdAt: '2024-09-01'
  },
  {
    id: 'yingyan-ai',
    title: '鹰眼 AI',
    titleEn: 'YingYan AI',
    description: '新一代智能视觉平台，融合深度学习与迁移学习技术，基于 MobileNetV2 预训练模型，实现快速部署和精准识别。',
    descriptionEn: 'A new generation intelligent vision platform that integrates deep learning and transfer learning technology, based on MobileNetV2 pre-trained model for fast deployment and accurate recognition.',
    category: 'ai',
    tags: ['Python', 'MobileNetV2', '迁移学习'],
    image: 'https://github.com/ctkqiang/YingYanAI/blob/main/assets/algorithm.png?raw=true',
    liveUrl: 'https://ctkqiang.xin/YingYanAI',
    createdAt: '2024-01-15'
  },
  {
    id: 'pawlyn',
    title: '宝玲宠物平台',
    titleEn: 'Pawlyn Pet Platform',
    description: '用于管理宠物诊所和医院的数字平台，提供完整的宠物医疗管理解决方案。',
    descriptionEn: 'A digital platform for managing pet clinics and hospitals, providing comprehensive pet medical management solutions.',
    category: 'app',
    tags: ['Flutter', '宠物医疗', '管理系统'],
    image: 'https://pawlynpet.vercel.app/assets/banner.png',
    liveUrl: 'https://pawlynpet.vercel.app/',
    createdAt: '2024-06-30'
  },
  {
    id: 'rfid',
    title: 'RFID 门禁系统',
    titleEn: 'RFID Access Control',
    description: '使用 RFID RC522 模块读取和验证 RFID 卡片的门禁系统，支持预定义标签 ID 的访问控制。',
    descriptionEn: 'An access control system using RFID RC522 module to read and verify RFID cards, supporting access control with predefined tag IDs.',
    category: 'iot',
    tags: ['嵌入式', 'C/C++', 'RFID'],
    image: 'https://picsum.photos/id/180/800/600',
    githubUrl: 'https://github.com/ctkqiang/RFID',
    createdAt: '2023-12-01'
  },
  {
    id: 'tongxinzhizhou',
    title: '铜心织宙',
    titleEn: 'TongXinZhiZhou',
    description: '先进的 PCB 分析系统，能够自动识别电路板上的元件、引脚和铜层走线，并生成可视化的原理图。',
    descriptionEn: 'An advanced PCB analysis system that can automatically identify components, pins, and copper traces on circuit boards and generate visual schematics.',
    category: 'ai',
    tags: ['计算机视觉', 'PCB', 'Python'],
    image: 'https://github.com/ctkqiang/TongXinZhiZhou/raw/main/output/schematics/schematic_20250312_031717.jpg',
    liveUrl: 'https://www.ctkqiang.xin/TongXinZhiZhou/',
    createdAt: '2024-03-12'
  },
  {
    id: 'lianjia-scraper',
    title: '链家房源数据爬虫',
    titleEn: 'LianJia Scraper',
    description: '基于 Spring Boot 的链家房源数据爬虫系统，支持自动采集房源信息，提供 Excel/CSV 导出功能和数据可视化界面。',
    descriptionEn: 'A Spring Boot-based Lianjia housing data crawler system that supports automatic collection of housing information, provides Excel/CSV export functionality and data visualization interface.',
    category: 'data',
    tags: ['Java', 'Spring Boot', '数据爬取'],
    image: 'https://www.ctkqiang.xin/LianJiaScraper/demo/%E6%88%AA%E5%B1%8F2025-02-10%20%E4%B8%8A%E5%8D%882.29.33.png',
    liveUrl: 'https://ctkqiang.xin/LianJiaScraper',
    createdAt: '2024-02-10'
  },
  {
    id: 'nezha-network-security',
    title: '哪吒网络安全',
    titleEn: 'NeZha Network Security',
    description: '基于 C++ 20 核心引擎与 Dart FFI 技术构建的高性能 Android 安全防护工具，提供毫秒级系统监控、隐私权限分析及 WiFi/蓝牙安全检测。',
    descriptionEn: 'A high-performance Android security protection tool built on C++ 20 core engine and Dart FFI technology, providing millisecond-level system monitoring, privacy permission analysis, and WiFi/Bluetooth security detection.',
    category: 'security',
    tags: ['C++', 'Dart', 'Android', '安全'],
    image: '/assets/nezhawangluanquan/logo.png',
    liveUrl: '/pages/nezha_wanluoanquan.html',
    featured: true,
    createdAt: '2024-10-01'
  },
  {
    id: 'niuma-ai',
    title: '牛马 AI',
    titleEn: 'NiuMa AI',
    description: '智能AI助手平台，集成多种AI能力，为用户提供便捷的智能服务体验。',
    descriptionEn: 'Intelligent AI assistant platform integrating multiple AI capabilities to provide users with a convenient intelligent service experience.',
    category: 'ai',
    tags: ['AI', 'Web App', 'Next.js'],
    image: 'https://picsum.photos/id/1/800/600',
    liveUrl: '/pages/niumaai.html',
    createdAt: '2024-08-01'
  },
  {
    id: 'qiankunquan',
    title: '乾坤圈',
    titleEn: 'QianKunQuan',
    description: '功能强大的网络安全扫描工具，专为渗透测试人员和安全研究人员设计。结合高效端口扫描、服务识别、版本检测和CVE漏洞关联等核心功能，帮助快速评估目标系统的安全状况。',
    descriptionEn: 'A powerful network security scanning tool designed for penetration testers and security researchers. Combines efficient port scanning, service identification, version detection, and CVE vulnerability correlation.',
    category: 'security',
    tags: ['Go', '网络安全', '扫描器', 'CVE'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/QianKunQuan',
    githubUrl: 'https://github.com/ctkqiang/QianKunQuan',
    featured: true,
    stars: 31,
    forks: 5,
    createdAt: '2025-07-08'
  },
  {
    id: 'nezhassec',
    title: '哪吒Sec',
    titleEn: 'NeZhaSec',
    description: '面向授权渗透测试的红队辅助工具。通过 DeepSeek 大模型的函数调用能力动态规划攻击路径，并自动执行 nmap、sqlmap、nuclei、ffuf 等常用安全工具，通过终端图形界面 (TUI) 实时展示。',
    descriptionEn: 'A red team assistant tool for authorized penetration testing. Uses DeepSeek LLM function calling to dynamically plan attack paths and automatically execute nmap, sqlmap, nuclei, ffuf and other common security tools with real-time TUI display.',
    category: 'security',
    tags: ['Go', 'DeepSeek', 'TUI', '红队'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/NeZhaSec',
    githubUrl: 'https://github.com/ctkqiang/NeZhaSec',
    featured: true,
    createdAt: '2025-04-13'
  },
  {
    id: 'huojianqiang',
    title: '火尖枪',
    titleEn: 'HuoJianQiang',
    description: '专为安全测试和性能验证设计的高性能 HTTP 批量请求工具。能够自动化执行大规模的用户名/密码组合测试，支持高度可配置的请求参数和多线程并发处理。',
    descriptionEn: 'A high-performance HTTP batch request tool designed for security testing and performance verification. Capable of automating large-scale username/password combination testing with highly configurable request parameters and multi-threaded concurrent processing.',
    category: 'security',
    tags: ['Go', 'HTTP', '并发', '安全测试'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/huo_jian_qiang',
    githubUrl: 'https://github.com/ctkqiang/huo_jian_qiang',
    createdAt: '2025-02-21'
  },
  {
    id: 'fenghuolun',
    title: '风火轮',
    titleEn: 'FengHuoLun',
    description: '基于 Go 语言开发的高性能、多源情报集成与自动化查询系统。通过统一 API 接口，高效地整合来自商业、社会安全等多个渠道的数据，为用户提供一站式的情报中枢服务。',
    descriptionEn: 'A high-performance, multi-source intelligence integration and automated query system built in Go. Efficiently integrates data from commercial and social security channels through a unified API interface.',
    category: 'security',
    tags: ['Go', '情报', 'API', '自动化'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/FengHuoLun',
    githubUrl: 'https://github.com/ctkqiang/FengHuoLun',
    createdAt: '2025-02-19'
  },
  {
    id: 'lingflow',
    title: 'LingFlow',
    titleEn: 'LingFlow',
    description: '基于 Go 语言构建的 WebSocket 实时 AI 聊天服务框架。通过 S3 动态技能加载赋能 LLM，实现可热更新的领域知识注入。采用事件溯源模式管理会话生命周期，支持流式响应。',
    descriptionEn: 'A WebSocket real-time AI chat service framework built in Go. Empowers LLMs through S3 dynamic skill loading for hot-updatable domain knowledge injection. Uses event sourcing pattern for session lifecycle management with streaming response support.',
    category: 'ai',
    tags: ['Go', 'WebSocket', 'LLM', 'AI'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/LingFlow',
    githubUrl: 'https://github.com/ctkqiang/LingFlow',
    createdAt: '2025-07-11'
  },
  {
    id: 'mouniu',
    title: '牟牛',
    titleEn: 'MouNiu',
    description: '基于 Go 语言开发的高性能股票数据抓取与技术指标分析系统。集成实时行情采集、多维技术指标计算、自动化公告监控以及标准化 RESTful API 服务，为量化交易和金融数据研究提供数据基础。',
    descriptionEn: 'A high-performance stock data scraping and technical indicator analysis system built in Go. Integrates real-time market data collection, multi-dimensional technical indicator calculation, automated announcement monitoring, and standardized RESTful API services.',
    category: 'data',
    tags: ['Go', '股票', '量化', 'RESTful API'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/MouNiu',
    githubUrl: 'https://github.com/ctkqiang/MouNiu',
    createdAt: '2025-04-22'
  },
  {
    id: 'cve-exploits',
    title: 'CVE-Exploits',
    titleEn: 'CVE-Exploits',
    description: '收集各种 CVE 漏洞的 PoC（概念验证）或 Exploit（漏洞利用）工具仓库。旨在为安全研究、渗透测试提供参考和便利。',
    descriptionEn: 'A collection of PoC (Proof of Concept) or Exploit tools for various CVE vulnerabilities. Designed to provide reference and convenience for security research and penetration testing.',
    category: 'security',
    tags: ['Go', 'CVE', 'PoC', '渗透测试'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/CVE-Exploits',
    githubUrl: 'https://github.com/ctkqiang/CVE-Exploits',
    createdAt: '2025-04-12'
  },
  {
    id: 'questexploit',
    title: 'QuestExploit',
    titleEn: 'QuestExploit',
    description: '基于 Go 语言开发的自动化安全测试工具。针对 QuestDB 数据库的身份验证机制进行深度探测，自动验证多种绕过手段，并演示成功绕过后攻击者可能执行的恶意操作。',
    descriptionEn: 'An automated security testing tool built in Go. Performs deep probing of QuestDB database authentication mechanisms, automatically verifying multiple bypass methods and demonstrating post-bypass malicious operations.',
    category: 'security',
    tags: ['Go', 'QuestDB', '漏洞利用', '安全测试'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/QuestExploit',
    githubUrl: 'https://github.com/ctkqiang/QuestExploit',
    createdAt: '2025-04-12'
  },
  {
    id: 'nezhacybermcp',
    title: 'NeZhaCyberMCP',
    titleEn: 'NeZhaCyberMCP',
    description: '聚合、存储和查询来自 CIRCL、MyCERT 和 GitHub Advisory Database 的安全公告，通过 MCP JSON-RPC 2.0 协议直接服务于你的 AI 助手。',
    descriptionEn: 'Aggregate, store, and query security advisories from CIRCL, MyCERT, and GitHub Advisory Database — served directly to your AI assistant via MCP JSON-RPC 2.0.',
    category: 'security',
    tags: ['Go', 'MCP', 'AI', '安全公告'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/NezhaCyberMCP',
    githubUrl: 'https://github.com/ctkqiang/NezhaCyberMCP',
    createdAt: '2025-07-07'
  },
  {
    id: 'authgate',
    title: 'AuthGate',
    titleEn: 'AuthGate',
    description: '多云统一认证网关。一套 Go 代码，三个运行环境——本地开发、AWS Lambda、阿里云 FC，共享单一路由表，零配置切换。',
    descriptionEn: 'Multi-cloud unified authentication gateway. One Go codebase, three runtime environments — local development, AWS Lambda, Alibaba Cloud FC — sharing a single route table with zero-config switching.',
    category: 'security',
    tags: ['Go', 'AWS Lambda', '阿里云', '认证'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/AuthGate',
    githubUrl: 'https://github.com/ctkqiang/AuthGate',
    createdAt: '2025-06-22'
  },
  {
    id: 'identitycardocr',
    title: 'IdentityCardOCR',
    titleEn: 'IdentityCardOCR',
    description: '生产级开源 AWS Lambda 服务，用于基于 OCR 的身份证件信息提取。支持中国居民身份证和马来西亚 MyKad/MyPR 证件。',
    descriptionEn: 'Production-grade, open-source AWS Lambda service for OCR-based identity document extraction. Supports Chinese Resident Identity Cards and Malaysian MyKad/MyPR documents.',
    category: 'ai',
    tags: ['Go', 'AWS Lambda', 'OCR', 'AI'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/IdentityCardOCR',
    githubUrl: 'https://github.com/ctkqiang/IdentityCardOCR',
    createdAt: '2025-06-07'
  },
  {
    id: 'flutter-sec',
    title: 'FlutterSec',
    titleEn: 'FlutterSec',
    description: '使用 Go 编写的命令行工具，用于扫描 Flutter 打包后的 APK 文件中的安全风险。通过调用 apktool 解包 APK，并静态分析 AndroidManifest.xml 等安全配置。',
    descriptionEn: 'A command-line tool written in Go for scanning security risks in Flutter-packaged APK files. Uses apktool to unpack APKs and performs static analysis of security configurations like AndroidManifest.xml.',
    category: 'security',
    tags: ['Go', 'Flutter', 'APK', '安全扫描'],
    image: 'https://opengraph.githubassets.com/1/ctkqiang/flutter_sec',
    githubUrl: 'https://github.com/ctkqiang/flutter_sec',
    createdAt: '2025-07-06'
  }
];

export const blogPosts: BlogPost[] = [
  {
    id: 'bug-bounty-1',
    title: '漏洞赏金猎人的一天',
    titleEn: 'A Day in the Life of a Bug Bounty Hunter',
    excerpt: '分享作为漏洞赏金猎人的日常工作流程和心得体会，从信息收集到漏洞挖掘的完整链路...',
    excerptEn: 'Sharing the daily workflow and experiences as a bug bounty hunter, from information gathering to vulnerability discovery...',
    date: '2024-12-15',
    category: '网络安全',
    url: 'https://www.ctkqiang.xin/bug-bounty-journal/',
    image: 'https://picsum.photos/id/0/800/400'
  },
  {
    id: 'ai-integration',
    title: 'AI 与全栈开发的完美融合',
    titleEn: 'Perfect Integration of AI and Full-Stack Development',
    excerpt: '探讨如何将机器学习模型无缝集成到现代Web应用中，打造智能化的用户体验...',
    excerptEn: 'Exploring how to seamlessly integrate machine learning models into modern web applications to create intelligent user experiences...',
    date: '2024-11-20',
    category: '人工智能',
    url: '#',
    image: 'https://picsum.photos/id/2/800/400'
  },
  {
    id: 'flutter-tips',
    title: 'Flutter 高性能开发实战技巧',
    titleEn: 'Flutter High-Performance Development Tips',
    excerpt: '深入解析Flutter性能优化的最佳实践，包括Widget优化、内存管理和渲染性能提升...',
    excerptEn: 'In-depth analysis of Flutter performance optimization best practices, including Widget optimization, memory management, and rendering performance improvements...',
    date: '2024-10-28',
    category: '移动开发',
    url: '#',
    image: 'https://picsum.photos/id/3/800/400'
  }
];

export const projectCategories = [
  { id: 'all', name: '全部作品', nameEn: 'All Projects', icon: 'fa-th-large' },
  { id: 'web', name: '网站开发', nameEn: 'Web Development', icon: 'fa-globe' },
  { id: 'app', name: '应用开发', nameEn: 'App Development', icon: 'fa-mobile-alt' },
  { id: 'ai', name: '人工智能', nameEn: 'AI / ML', icon: 'fa-brain' },
  { id: 'security', name: '网络安全', nameEn: 'Cybersecurity', icon: 'fa-shield-alt' },
  { id: 'data', name: '数据分析', nameEn: 'Data Analysis', icon: 'fa-chart-bar' },
  { id: 'blockchain', name: '区块链', nameEn: 'Blockchain', icon: 'fa-link' },
  { id: 'iot', name: '物联网', nameEn: 'IoT', icon: 'fa-microchip' }
];
